module.exports = __webpack_public_path__ + "img/lt-icone-phone-gris-claire.8be8045b.svg";